import { render, staticRenderFns } from "./menuDetail.vue?vue&type=template&id=ac8171ce&scoped=true&"
import script from "./menuDetail.vue?vue&type=script&lang=js&"
export * from "./menuDetail.vue?vue&type=script&lang=js&"
import style0 from "./menuDetail.vue?vue&type=style&index=0&id=ac8171ce&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8171ce",
  null
  
)

export default component.exports